<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapterNumber" id="_idParaDest-1"><a id="_idTOCAnchor-13"></a>Contents</h1>
<p class="center"><a href="#/MindOverGolf2#_idTOCAnchor-12">Acknowledgments</a></p>
<p class="center"><a href="#/MindOverGolf3#_idTOCAnchor-11">1. <br/>The importance of the<br/>psychological side of golf.</a></p>
<p class="center"><a href="#/MindOverGolf4#_idTOCAnchor-10">2. <br/>How fifty top pros rank the<br/>six major psychological factors.</a></p>
<p class="center"><a href="#/MindOverGolf5#_idTOCAnchor-9">3. <br/>How to improve your game<br/>through gaining new confidence.</a></p>
<p class="center"><a href="#/MindOverGolf6#_idTOCAnchor-8">4. <br/>How the pros rank the<br/>eight major golfing skills.</a></p>
<p class="center"><a href="#/MindOverGolf7#x.17576">5. <br/>Attributes and abilities the pros<br/>would like most to possess.</a></p>
<p class="center"><a href="#/MindOverGolf8#_idTOCAnchor-7">6. <br/>What the pros feel<br/>are their strengths.</a></p>
<p class="center"><a href="#/MindOverGolf9#_idTOCAnchor-6">7. <br/>What the pros feel<br/>we their weaknesses.</a></p>
<p class="center"><a href="#/MindOverGolf10#_idTOCAnchor-5">8. <br/>What the pros think<br/>about practice and layoffs.</a></p>
<p class="center"><a href="#/MindOverGolf11#_idTOCAnchor-4">9. <br/>Analysis of the “blank mind” theory.<br/>Mental tricks to help your driving and putting.</a></p>
<p class="center"><a href="#/MindOverGolf12#_idTOCAnchor-3">10. <br/>Caddies and conversation.</a></p>
<p class="center"><a href="#/MindOverGolf13#_idTOCAnchor-2">11. <br/>Dreams, superstition, and luck.</a></p>
<p class="center"><a href="#/MindOverGolf14#x.17599">12. <br/>When franquilizers and self-hypnosis fail, try prayer.</a></p>
<p class="center"><a href="#/MindOverGolf15#x.17602">13<br/>“Gamesmanship” among the touring pros. Real or imagined? Intentional or unintentional?</a></p>
<p class="center"><a href="#/MindOverGolf16#x.17605">14. <br/>A positive attitude; foundation for all other psychological strengths.</a></p>
<p class="center"><a href="#/MindOverGolf17#x.17608">Appendix<br/>Professional Golfers’ Questionnaire</a></p>
<p class="center"><a href="#/MindOverGolf18">Copyright</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MindOverGolf-1.vue?3810550d